export default __webpack_public_path__ + "static/media/tethys-token.ab8251e7.svg";